import Information from "./Information";

const InformationContainer = (props:any) => {
    return(
        <Information
        successInfoAlert={props.successInfoAlert}
        dismissSuccessAlert={props.dismissSuccessAlert}
        />
    )
}

export default InformationContainer;
